import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { D3TreeRendererComponent } from './d3-tree-renderer/d3-tree-renderer.component';

@NgModule({
    imports: [  ],
    exports: [ D3TreeRendererComponent ],
    declarations:  [ D3TreeRendererComponent ],
})
export class TreeRenderersModule { }
